import * as React from 'react';
export var CacheContext = React.createContext({ result: {}, setResult: function () { } });
export default (function (_a) {
    var children = _a.children;
    var state = React.useRef({});
    var setResult = function (objectRequest, result) {
        state.current[objectRequest] = result;
    };
    return (React.createElement(CacheContext.Provider, { value: { result: state.current, setResult: setResult } }, children));
});
//# sourceMappingURL=CacheContext.js.map